import React from 'react';
import {render} from 'react-dom';

import ArticleReactions from '../../website-ui/modules/article-reactions';

const initArticleReactions = ($wrapper, articleId, withOnBoarding = false) => {
  if ($wrapper) {
    render(
      <ArticleReactions articleId={articleId} withOnBoarding={withOnBoarding} />,
      $wrapper
    );
  }
};

export {initArticleReactions};
